module.exports = __webpack_public_path__ + "img/empty-development.d6002f79.svg";